import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

export const EditContainer = styled(Grid)({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "5px 0 10px",

  "& .MuiFormControl-root": {
    width: "60%",
  },
});

export const Header = styled(Grid)({
  width: "100%",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderBottom: "1px solid 	#E8E8E8",

  "& > .MuiTypography-root": {
    maxWidth: "75%",
  },

  "& > .MuiTypography-root, & > .MuiGrid-root > .MuiButtonBase-root": {
    fontSize: "1.1em",
  },

  // "& > .MuiGrid-root > .MuiIconButton-root": {
  //   visibility: "hidden",
  // },

  // "&:hover > .MuiGrid-root > .MuiIconButton-root": {
  //   visibility: "visible",
  // },
});

export const EditActions = styled(Grid)({
  display: "flex",
  gap: "10px",
});
